import { render, staticRenderFns } from "./listTypeTable.vue?vue&type=template&id=b62503fe&"
import script from "./listTypeTable.vue?vue&type=script&lang=js&"
export * from "./listTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports